import http from '../../api/http';
/**
 * 一卡通认证信息
 */
export const getAuthInfo=(params)=>  http("get", '/project/general/auth/verify', params)
/**
 * 根据账户id获取账户信息
 */
export const getAccInfo=(params)=>  http("get", '/account/info', params)